// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lq-1";
export var messageSideRight = "_lq-2";
export var orderLookupBubbleContainer = "_lq-0";
export var submitButton = "_lq-3";